import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Hospitals() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}